import React from 'react';

import { colors, styled } from 'core/styles';
import { ratingToLetter } from 'domain/types';

import { RatingHistory } from './RatingHistoryChart';

export function RatingHistoryTooltip({
  active,
  payload,
}: {
  active?: boolean;
  payload?: { payload: RatingHistory }[];
}) {
  if (active && payload && payload.length) {
    const point = payload[0].payload;
    return (
      <Root>
        <TooltipContent>Rating: {ratingToLetter(point.rating)}</TooltipContent>
      </Root>
    );
  }

  return null;
}

const Root = styled('div')(() => ({
  padding: 10,
  background: colors.smokyWhite,
  border: 'solid 2px #fff',
  borderRadius: 8,
}));

const TooltipContent = styled('p')(() => ({
  fontSize: 12,
  margin: 0,
}));
